/* Furmulate kit — fm.js
   Carousels, gallery, countdown, delivery date, sold bar, sticky add-to-cart,
   video tiles, review wall, header menu and the cart drawer. No dependencies. */
(function () {
  'use strict';

  var FM = (window.FM = window.FM || {});
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }
  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }
  function once(el, key) {
    if (el['__fm' + key]) return false;
    el['__fm' + key] = true;
    return true;
  }
  function rafThrottle(fn) {
    var queued = false;
    return function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        fn();
      });
    };
  }

  /* ---------- Carousels ---------- */
  function initCarousel(el) {
    if (!once(el, 'carousel')) return;
    var track = $('[data-fm-track]', el);
    if (!track) return;
    var prev = $('[data-fm-prev]', el);
    var next = $('[data-fm-next]', el);
    var bar = $('[data-fm-bar]', el);

    function step() {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    var update = rafThrottle(function () {
      var max = track.scrollWidth - track.clientWidth;
      el.classList.toggle('is-static', max <= 2);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (bar && track.scrollWidth > 0) {
        var w = (track.clientWidth / track.scrollWidth) * 100;
        var x = max > 0 ? (track.scrollLeft / max) * (100 - w) : 0;
        bar.style.setProperty('--w', w + '%');
        bar.style.setProperty('--x', x + '%');
      }
    });
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    update();
  }

  /* ---------- Product gallery ---------- */
  function initGallery(el) {
    if (!once(el, 'gallery')) return;
    var track = $('[data-fm-g-track]', el);
    if (!track) return;
    var slides = $$('.fm-gallery__slide', track);
    var dotsBox = $('[data-fm-g-dots]', el);
    var thumbs = $$('[data-fm-g-thumb]', el);
    if (slides.length < 2) {
      el.classList.add('fm-gallery--single');
      return;
    }
    var dots = [];
    if (dotsBox) {
      dotsBox.innerHTML = '';
      slides.forEach(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'fm-gallery__dot';
        b.setAttribute('aria-label', 'Image ' + (i + 1));
        b.addEventListener('click', function () { go(i); });
        dotsBox.appendChild(b);
        dots.push(b);
      });
    }
    function current() {
      return Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    var row = $('[data-fm-g-thumbs]', el);
    var update = rafThrottle(function () {
      var i = current();
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      var t = thumbs[i];
      if (row && t && row.scrollWidth > row.clientWidth) {
        row.scrollTo({ left: t.offsetLeft - (row.clientWidth - t.clientWidth) / 2, behavior: 'smooth' });
      }
    });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
    var prev = $('[data-fm-g-prev]', el);
    var next = $('[data-fm-g-next]', el);
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    track.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ---------- Countdown ---------- */
  function initCountdown(el) {
    if (!once(el, 'countdown')) return;
    var mode = el.getAttribute('data-mode') || 'daily';
    var endAttr = el.getAttribute('data-end');
    var h = $('[data-h]', el), m = $('[data-m]', el), s = $('[data-s]', el);
    function target() {
      if (mode === 'date' && endAttr) {
        var t = new Date(endAttr.replace(' ', 'T'));
        if (!isNaN(t)) return t;
      }
      var d = new Date();
      d.setHours(24, 0, 0, 0);
      return d;
    }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = Math.max(0, target() - new Date());
      var sec = Math.floor(left / 1000);
      var hh = Math.floor(sec / 3600);
      if (h) h.textContent = pad(Math.min(hh, 99));
      if (m) m.textContent = pad(Math.floor((sec % 3600) / 60));
      if (s) s.textContent = pad(sec % 60);
      if (left <= 0 && mode === 'date' && el.getAttribute('data-hide-after') === 'true') {
        var bar = el.closest('.fm-ann');
        if (bar) bar.hidden = true;
      }
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Delivery estimate ---------- */
  function addBusinessDays(date, days, skipWeekends) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (!skipWeekends || (wd !== 0 && wd !== 6)) added++;
    }
    return d;
  }
  function initDelivery(el) {
    if (!once(el, 'delivery')) return;
    var minD = parseInt(el.getAttribute('data-min') || '3', 10);
    var maxD = parseInt(el.getAttribute('data-max') || minD, 10);
    var skip = el.getAttribute('data-skip-weekends') !== 'false';
    var fmt = { weekday: 'short', month: 'short', day: 'numeric' };
    var now = new Date();
    var a = addBusinessDays(now, minD, skip).toLocaleDateString('en-US', fmt);
    var b = addBusinessDays(now, maxD, skip).toLocaleDateString('en-US', fmt);
    $$('[data-fm-date-min]', el).forEach(function (n) { n.textContent = a; });
    $$('[data-fm-date-max]', el).forEach(function (n) { n.textContent = b; });
  }

  /* ---------- Sold bar ---------- */
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.4 })
    : null;
  function initSold(el) {
    if (!once(el, 'sold')) return;
    if (io) io.observe(el);
    else el.classList.add('is-in');
  }

  /* ---------- Sticky add to cart ---------- */
  function initSticky(bar) {
    if (!once(bar, 'sticky')) return;
    // Visible from page load; hidden only while the main ATC is on screen.
    var atc = $('[data-fm-atc-anchor]');
    if (!atc || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    var atcIn = false;
    var others = $$('[data-fm-hide-sticky]');
    var othersIn = 0;
    function apply() {
      bar.classList.toggle('is-visible', !atcIn && othersIn === 0);
    }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { atcIn = e.isIntersecting; });
      apply();
    }).observe(atc);
    // Mirror the selected bundle's SAVE badge.
    var save = $('[data-fm-sticky-save]', bar);
    function syncSave() {
      var badge = $('[data-pdo-main] [data-pdo-tier].is-selected .pdo-card__save');
      if (!save) return;
      save.textContent = badge ? badge.textContent.trim() : '';
      save.hidden = !badge;
    }
    syncSave();
    document.addEventListener('pdp-offer:change', syncSave);
    if (others.length) {
      var seen = new Map();
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { seen.set(e.target, e.isIntersecting); });
        othersIn = 0;
        seen.forEach(function (v) { if (v) othersIn++; });
        apply();
      });
      others.forEach(function (o) { obs.observe(o); });
    }
  }

  /* ---------- Video tiles ---------- */
  function initVideo(tile) {
    if (!once(tile, 'video')) return;
    var video = $('video', tile);
    var btn = $('[data-fm-play]', tile);
    if (!video || !btn) return;
    function toggle() {
      if (video.paused) {
        $$('[data-fm-video] video').forEach(function (v) {
          if (v !== video) {
            v.pause();
            v.closest('[data-fm-video]').classList.remove('is-playing');
          }
        });
        video.muted = false;
        video.controls = true;
        video.play();
        tile.classList.add('is-playing');
      } else {
        video.pause();
        tile.classList.remove('is-playing');
      }
    }
    btn.addEventListener('click', toggle);
    video.addEventListener('pause', function () { tile.classList.remove('is-playing'); });
    video.addEventListener('play', function () { tile.classList.add('is-playing'); });
  }

  /* ---------- Review wall ---------- */
  function initWall(wall) {
    if (!once(wall, 'wall')) return;
    var btn = $('[data-fm-more]', wall);
    if (!btn) return;
    var stepN = parseInt(wall.getAttribute('data-step') || '6', 10);
    btn.addEventListener('click', function () {
      var hidden = $$('.fm-review.is-hidden', wall);
      hidden.slice(0, stepN).forEach(function (r) { r.classList.remove('is-hidden'); });
      if ($$('.fm-review.is-hidden', wall).length === 0) btn.closest('.fm-cta').hidden = true;
    });
  }

  /* ---------- Header menu ---------- */
  function initHeader(header) {
    if (!once(header, 'header')) return;
    var btn = $('[data-fm-menu-toggle]', header);
    var menu = $('[data-fm-menu]', header);
    if (btn && menu) {
      btn.addEventListener('click', function () {
        var open = menu.hidden;
        menu.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      $$('a', menu).forEach(function (a) {
        a.addEventListener('click', function () {
          menu.hidden = true;
          btn.setAttribute('aria-expanded', 'false');
        });
      });
    }
    var h = header.getBoundingClientRect().height;
    if (h) document.documentElement.style.setProperty('--fm-header-h', Math.round(h) + 'px');
  }

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    cents = Number(cents || 0);
    format = format || '${{amount}}';
    function withDelims(n, precision, thousands, decimal) {
      var parts = (n / 100).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        default: return withDelims(cents, 2, ',', '.');
      }
    });
  }
  FM.formatMoney = formatMoney;

  /* ---------- Cart drawer ---------- */
  var Cart = (FM.cart = FM.cart || {});
  var drawer = null;
  var lastOpener = null;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function isGift(item) {
    return !!(item.properties && (item.properties._free_gift || item.properties._gift));
  }
  /* Offer data (tiers + gifts) printed by the product offer, used for savings and the upgrade */
  function offerData() {
    var el = document.querySelector('[data-pdo-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function tierOf(data, variantId) {
    if (!data) return null;
    for (var i = 0; i < data.tiers.length; i++) if (data.tiers[i].variantId === variantId || (data.tiers[i].subVariantId && data.tiers[i].subVariantId === variantId)) return data.tiers[i];
    return null;
  }
  function giftOf(data, variantId) {
    if (!data) return null;
    for (var i = 0; i < data.gifts.length; i++) if (data.gifts[i].variantId === variantId || (data.gifts[i].subVariantId && data.gifts[i].subVariantId === variantId)) return data.gifts[i];
    return null;
  }
  /* Recapitulatif d'un palier : son titre, puis le nombre reel de cadeaux qu'il
     debloque, livraison comprise, accorde en nombre. Le titre de variante
     Shopify ("2 Bottle + 1 Free Gifts") n'est pas utilise : il est fige cote
     produit et se desynchronise des paliers. */
  function bundleRecap(tier) {
    var n = tier.giftCount || 0;
    if (!n) return tier.title;
    var s = n === 1
      ? (drawer.getAttribute('data-bundle-gift-one') || '+ [N] Free Gift')
      : (drawer.getAttribute('data-bundle-gift-many') || '+ [N] Free Gifts');
    return tier.title + ' ' + tpl(s, { N: n });
  }
  /* Economie d'un palier. Source unique : saveCents / giftsValueCents sont
     calcules en Liquid par snippets/fm-offer.liquid et publies dans
     data-pdo-data. Le panier ne refait pas le calcul, il le lit. */
  /* Offre A : cadeaux, livraison offerte et prix abonne = lignes abonnees (Loop) seulement. */
  function isSub(item) {
    return !!(item && item.selling_plan_allocation && item.selling_plan_allocation.selling_plan);
  }
  /* Protection de livraison : ligne payante ajoutee cochee, retirable, seulement
     si un produit de la liste data-protect-for est au panier. Le choix "decocher"
     est garde pour la session. */
  var PROTECT_KEY = 'fmProtectOff';
  function protectCfg() {
    if (!drawer) return null;
    var v = parseInt(drawer.getAttribute('data-protect-variant') || '0', 10);
    if (!v) return null;
    var ids = (drawer.getAttribute('data-protect-for') || '').split(',').filter(Boolean).map(Number);
    return { v: v, ids: ids, price: parseInt(drawer.getAttribute('data-protect-price') || '0', 10) };
  }
  function isProtect(item) {
    var c = protectCfg();
    return !!(c && item && (item.variant_id || item.id) === c.v);
  }
  function protectOff() { try { return sessionStorage.getItem(PROTECT_KEY) === '1'; } catch (e) { return false; } }
  function setProtectOff(on) { try { if (on) sessionStorage.setItem(PROTECT_KEY, '1'); else sessionStorage.removeItem(PROTECT_KEY); } catch (e) {} }
  function syncProtect(cart) {
    var c = protectCfg();
    if (!c || !cart || !cart.items) return Promise.resolve(cart);
    var has = cart.items.filter(isProtect);
    var eligible = c.ids.length > 0 && cart.items.some(function (i) {
      return !isProtect(i) && !isGift(i) && !isSub(i) && c.ids.indexOf(i.product_id) > -1;
    });
    var u = {};
    if (eligible && !has.length && !protectOff()) {
      return post('cart/add.js', { items: [{ id: c.v, quantity: 1, properties: { _shipping_protection: '1' } }] }).then(fetchCart);
    }
    if (!eligible && has.length) {
      has.forEach(function (h) { u[h.key] = 0; });
      return post('cart/update.js', { updates: u }).then(fetchCart);
    }
    if (has.length > 1 || (has.length && has[0].quantity !== 1)) {
      has.forEach(function (h, i) { u[h.key] = i === 0 ? 1 : 0; });
      return post('cart/update.js', { updates: u }).then(fetchCart);
    }
    return Promise.resolve(cart);
  }
  function lineSave(tier, quantity, sub) {
    if (!tier) return 0;
    var units = tier.quantity ? quantity / tier.quantity : 1;
    if (sub && tier.subCents) return Math.round((tier.compareCents - tier.subCents) * units) + (tier.giftsValueCents || 0);
    return Math.max(0, Math.round((tier.compareCents - tier.cents) * units));
  }
  function tierSavings(tier, quantity) {
    if (!tier) return 0;
    var units = tier.quantity ? quantity / tier.quantity : 1;
    if (units === 1) return tier.saveCents || 0;
    return Math.round((tier.compareCents - tier.cents) * units) + (tier.giftsValueCents || 0);
  }
  /* Cadeaux d'un palier, rendus SOUS sa ligne produit, dans la meme carte.
     Source unique : data-pdo-data, donc le nom, la vignette et la valeur
     viennent du bloc cadeau, jamais d'une saisie separee. La livraison
     offerte est un cadeau comme les autres. Aucun cadeau : aucun conteneur. */
  function giftRows(data, tier, fmt) {
    if (!data || !tier) return '';
    var list = data.gifts.filter(function (g) { return g.unlockAt <= tier.index; });
    if (!list.length) return '';
    var free = drawer.getAttribute('data-gift-free') || '+ FREE';
    return '<div class="fm-line__gifts">' + list.map(function (g) {
      return '<div class="fm-gline">' +
        (g.image ? '<span class="fm-gline__pic"><img src="' + esc(g.image) + '" alt="" loading="lazy"></span>' : '') +
        '<span class="fm-gline__free">' + esc(free) + '</span>' +
        '<span class="fm-gline__name">' + esc(g.name) + '</span>' +
        (g.valueCents ? '<s class="fm-gline__val">' + formatMoney(g.valueCents, fmt) + '</s>' : '') +
        '</div>';
    }).join('') + '</div>';
  }
  function tpl(str, map) {
    return String(str || '').replace(/\[([A-Z]+)\]/g, function (m, k) { return k in map ? map[k] : m; });
  }
  function imgUrl(url, w) {
    if (!url) return '';
    if (/^data:/.test(url)) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function setCount(n) {
    $$('[data-fm-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-count', n);
    });
  }
  function fetchCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function render(cart) {
    if (!drawer) return cart;
    var fmt = drawer.getAttribute('data-money-format');
    var items = $('[data-fm-cart-items]', drawer);
    var foot = $('[data-fm-cart-foot]', drawer);
    var ship = $('[data-fm-cart-ship]', drawer);
    var protLines = cart.items.filter(isProtect);
    var protCents = protLines.reduce(function (n, i) { return n + i.final_line_price; }, 0);
    var protBox = $('[data-fm-protect]', drawer);
    if (protBox) {
      var protInput = $('[data-fm-protect-input]', protBox);
      var protCfg = protectCfg();
      var protEligible = protCfg && protCfg.ids.length && cart.items.some(function (i) { return !isProtect(i) && !isGift(i) && !isSub(i) && protCfg.ids.indexOf(i.product_id) > -1; });
      protBox.hidden = !protEligible;
      if (protInput) protInput.checked = protLines.length > 0;
    }
    var paid = cart.items.filter(function (i) { return !isGift(i) && !isProtect(i); });
    var giftCount = cart.items.filter(isGift).length;
    var count = paid.reduce(function (n, i) { return n + i.quantity; }, 0) + giftCount;
    setCount(count);

    var countTitle = $('[data-fm-cart-count-title]', drawer);
    if (countTitle) countTitle.textContent = count ? '(' + count + ')' : '';
    drawer.classList.toggle('is-empty', !cart.items.length);

    if (!cart.items.length) {
      items.innerHTML = $('[data-fm-cart-empty]', drawer).innerHTML;
      foot.hidden = true;
      if (ship) ship.hidden = true;
      renderUpgrade(cart, null);
      return cart;
    }
    foot.hidden = false;
    var data = offerData();
    var savings = 0;
    var shipFree = false;

    /* Un cadeau deja liste sous sa ligne produit n'est pas repris en ligne
       autonome. Ceux qui ne le sont pas gardent l'ancien rendu. */
    var covered = {};
    cart.items.forEach(function (it) {
      if (isGift(it) || !(isSub(it) || (data && data.giftsAlways))) return;
      var ct = tierOf(data, it.variant_id || it.id);
      if (!ct || !data) return;
      data.gifts.forEach(function (g) {
        if (g.unlockAt <= ct.index && g.variantId) covered[g.variantId] = true;
        if (g.unlockAt <= ct.index && g.subVariantId) covered[g.subVariantId] = true;
      });
    });

    /* Display order: bundles and paid items first, free gifts after (line numbers stay Shopify's) */
    var ordered = cart.items.map(function (item, idx) { return { item: item, line: idx + 1 }; });
    ordered.sort(function (a, b) { return (isGift(a.item) ? 1 : 0) - (isGift(b.item) ? 1 : 0) || a.line - b.line; });
    items.innerHTML = ordered.map(function (entry) {
      var item = entry.item;
      var line = entry.line;
      var gift = isGift(item);
      if (isProtect(item)) return '';
      if (gift && covered[item.variant_id || item.id]) return '';
      var props = Object.keys(item.properties || {}).filter(function (k) {
        return k.charAt(0) !== '_' && item.properties[k];
      }).map(function (k) { return esc(k) + ': ' + esc(item.properties[k]); });
      var tier = gift ? null : tierOf(data, item.variant_id || item.id);
      var sub = isSub(item);
      var meta = [];
      if (tier) meta.push(esc(sub ? bundleRecap(tier) : tier.title));
      else if (item.variant_title && !item.product_has_only_default_variant) meta.push(esc(item.variant_title));
      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) meta.push(esc(item.selling_plan_allocation.selling_plan.name));
      meta = meta.concat(props);
      var ref = 0;
      if (gift) {
        var g = giftOf(data, item.variant_id || item.id);
        if (g && g.valueCents) ref = g.valueCents * item.quantity;
        /* Rien ajoute a savings : la valeur des cadeaux est deja dans
           tierSavings(), sinon elle serait comptee deux fois. */
      } else if (tier) {
        if (tier.compareCents * item.quantity / (tier.quantity || 1) > item.final_line_price && tier.quantity) ref = Math.round(tier.compareCents * item.quantity / tier.quantity);
        if (!ref && item.original_line_price > item.final_line_price) ref = item.original_line_price;
        savings += lineSave(tier, item.quantity, sub);
        if (sub) shipFree = shipFree || !!tier.hasShipping;
      } else {
        if (item.original_line_price > item.final_line_price) ref = item.original_line_price;
        if (ref > item.final_line_price) savings += ref - item.final_line_price;
      }
      var price = gift
        ? '<span class="fm-line__price">' + esc(drawer.getAttribute('data-free-label') || 'FREE') + '</span>' +
          (ref ? '<span class="fm-line__value">' + formatMoney(ref, fmt) + '</span>' : '')
        : '<span class="fm-line__price">' + formatMoney(item.final_line_price, fmt) + '</span>' +
          (ref > item.final_line_price ? '<span class="fm-line__compare">' + formatMoney(ref, fmt) + '</span>' : '');
      return '<div class="fm-line" data-line="' + line + '">' +
        '<div class="fm-line__img">' + (item.image ? '<img src="' + esc(imgUrl(item.image, 180)) + '" alt="" loading="lazy" width="72" height="72">' : '') + '</div>' +
        '<div class="fm-line__info"><div class="fm-line__title">' + esc(item.product_title) + '</div>' +
        (meta.length ? '<div class="fm-line__meta">' + meta.join(' · ') + '</div>' : '') +
        (gift ? '<span class="fm-line__free">' + esc(drawer.getAttribute('data-gift-label') || 'Free gift') + '</span>'
              : '<div class="fm-line__qty"><button type="button" data-qty="-1" aria-label="Decrease">−</button><span>' + item.quantity + '</span><button type="button" data-qty="1" aria-label="Increase">+</button></div>') +
        '</div>' +
        '<div class="fm-line__right">' + price + (gift ? '' : '<button type="button" class="fm-line__remove" data-remove>' + esc(drawer.getAttribute('data-remove-label') || 'Remove') + '</button>') + '</div>' +
        ((sub || (data && data.giftsAlways)) ? giftRows(data, tier, fmt) : '') +
        '</div>';
    }).join('');

    var total = $('[data-fm-cart-total]', drawer);
    var was = $('[data-fm-cart-was]', drawer);
    if (total) total.textContent = formatMoney(cart.total_price, fmt);
    if (was) {
      was.textContent = cart.original_total_price > cart.total_price ? formatMoney(cart.original_total_price, fmt) : '';
    }
    var save = $('[data-fm-cart-save]', drawer);
    if (save) {
      var saved = savings + (cart.total_discount || 0);
      save.hidden = !saved;
      save.textContent = saved ? (drawer.getAttribute('data-save-label') || 'You save [AMOUNT]').replace('[AMOUNT]', formatMoney(saved, fmt)) : '';
    }
    renderUpgrade(cart, data);
    renderUpsells(cart);

    if (ship) {
      var threshold = parseInt(drawer.getAttribute('data-threshold') || '0', 10);
      var bar = $('[data-fm-ship-bar]', ship);
      var barWrap = bar ? bar.parentNode : null;
      if (shipFree) {
        /* Le palier au panier offre deja la livraison : on confirme, on ne
           reclame pas un complement, et la jauge disparait. */
        ship.hidden = false;
        ship.classList.add('is-done');
        if (barWrap) barWrap.hidden = true;
        $('[data-fm-ship-msg]', ship).innerHTML = drawer.getAttribute('data-ship-done') || "You've unlocked FREE shipping!";
      } else if (threshold > 0) {
        ship.hidden = false;
        ship.classList.remove('is-done');
        if (barWrap) barWrap.hidden = false;
        var shipBase = cart.total_price - protCents;
        var left = threshold - shipBase;
        var msg = left > 0
          ? (drawer.getAttribute('data-ship-left') || 'Add [AMOUNT] more for FREE shipping').replace('[AMOUNT]', '<strong>' + formatMoney(left, fmt) + '</strong>')
          : (drawer.getAttribute('data-ship-done') || "You've unlocked FREE shipping!");
        $('[data-fm-ship-msg]', ship).innerHTML = msg;
        if (bar) bar.style.width = Math.min(100, (shipBase / threshold) * 100) + '%';
      } else {
        ship.hidden = true;
      }
    }
    return cart;
  }

  /* Next bundle: price difference + gifts it adds, one click to swap */
  function renderUpgrade(cart, data) {
    var box = $('[data-fm-upgrade]', drawer);
    if (!box) return;
    box.hidden = true;
    box.innerHTML = '';
    if (!data || drawer.getAttribute('data-upgrade') === 'false' || !cart.items.length) return;
    var fmt = drawer.getAttribute('data-money-format');
    var line = -1, item = null, cur = null;
    cart.items.forEach(function (it, idx) {
      if (item || isGift(it)) return;
      var t = tierOf(data, it.variant_id || it.id);
      if (t && it.quantity === t.quantity) { line = idx + 1; item = it; cur = t; }
    });
    if (!cur) return;
    var next = null;
    data.tiers.forEach(function (t) { if (!next && t.index === cur.index + 1 && t.variantId) next = t; });
    if (!next) return;
    /* Ligne abonnee (Loop) : on compare les prix abonnes et on garde le plan au changement de palier. */
    var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan ? item.selling_plan_allocation.selling_plan.id : null;
    var diff = plan && next.subCents && cur.subCents ? next.subCents - cur.subCents : next.cents - cur.cents;
    if (diff <= 0) return;
    var newGifts = plan ? data.gifts.filter(function (g) { return g.unlockAt > cur.index && g.unlockAt <= next.index; }) : [];
    var names = newGifts.map(function (g) { return g.name; }).join(' + ');
    /* Gain total du passage au palier suivant : meme formule que le badge SAVE,
       lue dans data-pdo-data. L'ancien calcul ne comparait que les flacons. */
    var extraSave = Math.max(0, lineSave(next, next.quantity, !!plan) - lineSave(cur, cur.quantity, !!plan));
    var saveStr = formatMoney(extraSave, fmt);
    /* Sous-texte en deux segments courts, une ligne chacun, pour tenir la carte
       sur une seule rangee. Sans nouveau cadeau, la ligne 1 s'arrete avant le point median. */
    var l1 = drawer.getAttribute('data-upgrade-line1') || '+[DIFF] \u00b7 adds [GIFTS]';
    if (!names) l1 = l1.split('\u00b7')[0].trim();
    var text = '<span class="fm-upgrade__sub">' +
      tpl(l1, { DIFF: '<b>' + formatMoney(diff, fmt) + '</b>', GIFTS: esc(names) }) + '</span>';
    if (extraSave > 0) {
      text += '<span class="fm-upgrade__sub">' +
        tpl(drawer.getAttribute('data-upgrade-line2') || 'Save [SAVE] more', { SAVE: '<b>' + saveStr + '</b>' }) + '</span>';
    }
    var imgEl = document.querySelector('[data-pdo-main] .pdo-card[data-pdo-tier="' + next.index + '"] .pdo-card__thumb img');
    var img = imgEl ? imgEl.currentSrc || imgEl.src : (item.image ? imgUrl(item.image, 180) : '');
    var badge = drawer.getAttribute('data-upgrade-badge');
    box.innerHTML = '<div class="fm-upgrade">' +
      (badge ? '<span class="fm-upgrade__badge">' + esc(badge) + '</span>' : '') +
      '<span class="fm-upgrade__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span>' +
      '<span class="fm-upgrade__txt"><span class="fm-upgrade__title">' + esc(tpl(drawer.getAttribute('data-upgrade-title'), { TIER: next.title })) + '</span>' +
      '<span class="fm-upgrade__subs">' + text + '</span></span>' +
      '<button type="button" class="fm-upgrade__btn" data-fm-upgrade-btn>' + esc(drawer.getAttribute('data-upgrade-button') || 'Upgrade') + '</button>' +
      '</div>';
    box.hidden = false;
    $('[data-fm-upgrade-btn]', box).addEventListener('click', function () {
      busy(true);
      var add = [{ id: next.subVariantId || next.variantId, quantity: next.quantity, properties: item.properties || {} }];
      if (plan) add[0].selling_plan = next.planId || plan;
      newGifts.forEach(function (g) {
        var gid = g.subVariantId;
        if (gid && !cart.items.some(function (i) { return (i.variant_id || i.id) === gid; })) {
          add.push({ id: gid, quantity: 1, properties: plan ? { _free_gift: 'true' } : { _gift: 'Free gift' } });
        }
      });
      post('cart/change.js', { line: line, quantity: 0 })
        .then(function () { return post('cart/add.js', { items: add }); })
        .then(fetchCart)
        .then(render)
        .catch(function (e) { console.error('[fm-cart]', e); })
        .then(function () { busy(false); });
    });
  }

  function renderUpsells(cart) {
    var wrap = $('[data-fm-upsells]', drawer);
    if (!wrap) return;
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = true; inCart[i.variant_id || i.id] = true; });
    var shown = 0;
    $$('[data-fm-upsell]', wrap).forEach(function (card) {
      var hide = inCart[parseInt(card.getAttribute('data-product-id'), 10)] || inCart[parseInt(card.getAttribute('data-variant-id'), 10)];
      card.hidden = !!hide;
      if (!hide) shown++;
    });
    wrap.hidden = shown === 0;
  }

  function busy(on) {
    if (drawer) drawer.classList.toggle('is-busy', !!on);
  }
  /* Free gifts leave with the bundle: if no bundle line is left, the gift lines are removed too */
  function cleanGiftsOnly(cart) {
    var gifts = cart.items.filter(isGift);
    if (!gifts.length) return Promise.resolve(cart);
    var data = offerData();
    var hasBundle = cart.items.some(function (i) {
      return !isGift(i) && (!data || tierOf(data, i.variant_id || i.id));
    });
    if (hasBundle) return Promise.resolve(cart);
    var updates = {};
    gifts.forEach(function (g) { updates[g.key] = 0; });
    return post('cart/update.js', { updates: updates }).then(fetchCart);
  }
  function change(line, quantity) {
    busy(true);
    return post('cart/change.js', { line: line, quantity: quantity })
      .then(cleanGiftsOnly)
      .then(syncProtect)
      .then(render)
      .catch(function (e) { console.error('[fm-cart]', e); })
      .then(function () { busy(false); });
  }

  Cart.refresh = function () {
    return fetchCart().then(syncProtect).then(render);
  };
  Cart.open = function (refresh) {
    if (!drawer) {
      window.location.href = root + 'cart';
      return;
    }
    lastOpener = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('fm-lock');
    var close = $('[data-fm-cart-close]', drawer);
    if (close) setTimeout(function () { close.focus(); }, 50);
    if (refresh !== false) Cart.refresh();
  };
  Cart.close = function () {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('fm-lock');
    if (lastOpener && lastOpener.focus) lastOpener.focus();
  };

  function initDrawer(el) {
    if (!once(el, 'drawer')) return;
    drawer = el;
    $$('[data-fm-cart-close]', el).forEach(function (b) { b.addEventListener('click', Cart.close); });
    el.addEventListener('change', function (e) {
      var inp = e.target.closest && e.target.closest('[data-fm-protect-input]');
      if (!inp) return;
      var on = inp.checked;
      setProtectOff(!on);
      busy(true);
      fetchCart().then(function (cart) {
        if (on) return syncProtect(cart);
        var u = {};
        cart.items.filter(isProtect).forEach(function (h) { u[h.key] = 0; });
        return Object.keys(u).length ? post('cart/update.js', { updates: u }).then(fetchCart) : cart;
      }).then(render)
        .catch(function (err) { console.error('[fm-cart]', err); })
        .then(function () { busy(false); });
    });
    el.addEventListener('click', function (e) {
      var up = e.target.closest('[data-fm-upsell-add]');
      if (up) {
        var card = up.closest('[data-fm-upsell]');
        busy(true);
        post('cart/add.js', { items: [{ id: parseInt(card.getAttribute('data-variant-id'), 10), quantity: 1 }] })
          .then(fetchCart)
          .then(syncProtect)
          .then(render)
          .catch(function (err) { console.error('[fm-cart]', err); })
          .then(function () { busy(false); });
        return;
      }
      var q = e.target.closest('[data-qty]');
      var r = e.target.closest('[data-remove]');
      var lineEl = e.target.closest('[data-line]');
      if (!lineEl || (!q && !r)) return;
      var line = parseInt(lineEl.getAttribute('data-line'), 10);
      if (r) return change(line, 0);
      var current = parseInt($('.fm-line__qty span', lineEl).textContent, 10) || 0;
      change(line, Math.max(0, current + parseInt(q.getAttribute('data-qty'), 10)));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) Cart.close();
    });
    Cart.refresh();
  }

  /* The offer block calls this after a successful add to cart */
  var offerApi = (window.PDPOffer = window.PDPOffer || {});
  offerApi.afterAdd = function () {
    Cart.open(true);
  };

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-fm-cart-open]');
    if (opener) {
      e.preventDefault();
      Cart.open(true);
    }
  });

  /* ---------- Boot ---------- */
  function init(scope) {
    $$('[data-fm-carousel]', scope).forEach(initCarousel);
    $$('[data-fm-gallery]', scope).forEach(initGallery);
    $$('[data-fm-countdown]', scope).forEach(initCountdown);
    $$('[data-fm-delivery]', scope).forEach(initDelivery);
    $$('[data-fm-sold]', scope).forEach(initSold);
    $$('[data-fm-sticky]', scope).forEach(initSticky);
    $$('[data-fm-video]', scope).forEach(initVideo);
    $$('[data-fm-wall]', scope).forEach(initWall);
    $$('[data-fm-header]', scope).forEach(initHeader);
    $$('[data-fm-drawer]', scope).forEach(initDrawer);
  }
  FM.init = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* v2 — onglets "Tell Me About". Delegation, plusieurs instances possibles. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-fm-tab]');
    if (!btn) return;
    var root = btn.closest('[data-fm-tabs]');
    if (!root) return;
    e.preventDefault();
    var target = btn.getAttribute('data-fm-tab');
    root.querySelectorAll('[data-fm-tab]').forEach(function (b) {
      b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
    });
    root.querySelectorAll('[data-fm-panel]').forEach(function (p) {
      p.hidden = p.id !== target;
    });
  });
})();

/* v2 — carrousel "Stock Up" : fleches + points, scroll-snap natif. */
(function () {
  function init(rail) {
    var track = rail.querySelector('[data-fm-rail-track]');
    if (!track) return;
    var slides = rail.querySelectorAll('[data-fm-rail-slide]');
    var dots = rail.querySelectorAll('[data-fm-rail-dot]');
    var prev = rail.querySelector('[data-fm-rail-prev]');
    var next = rail.querySelector('[data-fm-rail-next]');
    function step() {
      var s = slides[0];
      if (!s) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;
      return s.getBoundingClientRect().width + gap;
    }
    function sync() {
      var i = Math.round(track.scrollLeft / Math.max(step(), 1));
      dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    dots.forEach(function (d, n) {
      d.addEventListener('click', function () { track.scrollTo({ left: n * step(), behavior: 'smooth' }); });
    });
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; sync(); });
    }, { passive: true });
    sync();
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-fm-rail]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
